import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Form extends Component {
  getChildContext() {
    return {
      _connectedForm: {
        store: this.props.formStore
      }
    };
  }
  componentWillUnmount() {
    this.props.formStore.clearValues();
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { onSubmit, formStore } = this.props;
    if (onSubmit) {
      const values = formStore.getFormValues();
      formStore.setFormToSubmittedState();
      Promise.resolve().then(() => onSubmit(values)).then(
        () => {
          formStore.resetFormFromSubmittedState(true);
        },
        (error) => {
          formStore.resetFormFromSubmittedState(false);
        }
      );
    }
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit} className={this.props.className} autoComplete="off">
        {this.props.children}
      </form>
    );
  }

  static childContextTypes = {
    _connectedForm: PropTypes.object
  };
}

export default Form;



// WEBPACK FOOTER //
// ./src/common/core/forms/Form.jsx